import React from 'react';
import './WizardStepBar.css';

const WizardStepBar = ({ steps, currentStep, completedSteps, onStepClick }) => {
    return (
        <div className="wizard-step-bar">
            {steps.map((step, index) => {
                const isActive = index === currentStep;
                const isCompleted = completedSteps.has(index);
                const isClickable = isCompleted || isActive;

                let className = 'wizard-step';
                if (isActive) className += ' active';
                if (isCompleted) className += ' completed';

                return (
                    <React.Fragment key={step.key}>
                        {index > 0 && (
                            <div className={`wizard-step-connector${isCompleted || isActive ? ' completed' : ''}`} />
                        )}
                        <div
                            className={className}
                            onClick={() => isClickable && onStepClick(index)}
                        >
                            <div className="wizard-step-circle">
                                {isCompleted ? '\u2713' : index + 1}
                            </div>
                            <span className="wizard-step-label">{step.label}</span>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default WizardStepBar;
